import { addHours, isAfter } from 'date-fns'
import { computed, makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import { UndoableDTO } from 'src/dto/UndoableDTO'

import { typeSafeAssign } from '@/utils/common'

export class StudentWorksheet extends UndoableDTO implements res.StudentWorksheet {
  id = EMPTY_NUMBER_ID
  assignDatetime = new Date()
  openDatetime?: Date
  scoreDatetime?: Date
  createDatetime?: Date
  score: res.StudentWorksheet['score'] = null
  status = 'INCOMPLETE' as res.StudentWorksheet['status']
  studentHomeworkId: res.StudentWorksheet['studentHomeworkId'] = null
  worksheet = {
    id: EMPTY_NUMBER_ID,
    type: 'CUSTOM',
    title: '',
    titleTag: '',
    tag: 'BASIC',
    autoScorable: false,
    problemCount: 0,
    level: 1,
    school: 'ELEMENTARY',
    grade: '1',
    chapter: '',
    filterType: null,
    originWorkbook: null,
  } as res.StudentWorksheet['worksheet']

  constructor(data?: res.StudentWorksheet) {
    super()
    makeObservable(this, {
      id: observable,
      assignDatetime: observable,
      scoreDatetime: observable,
      score: observable,
      status: observable,
      studentHomeworkId: observable,
      worksheet: observable,
      canAssignHomework: computed,
    })
    if (data) typeSafeAssign(this, data)
  }

  get isNewAssigned() {
    return isAfter(addHours(this.assignDatetime, 24), new Date())
  }

  get korWorksheetLevel() {
    switch (this.worksheet.level) {
      case 1:
        return '하'
      case 2:
        return '중하'
      case 3:
        return '중'
      case 4:
        return '상'
      case 5:
        return '최상'
    }
  }

  get assignButtonStatus() {
    switch (this.status) {
      case 'INCOMPLETE':
        return '채점'
      case 'PROGRESS':
        return '이어 채점'
      case 'COMPLETE':
        return `${this.score || 0}점`
    }
  }

  get canAssignHomework() {
    return !this.studentHomeworkId
  }
}
